export default {
  checkout_order_id: 'Número de orden de checkout',
  attempts: 'Número de intentos',
  check_transactions: 'Ver transacciones',
  customer_name: 'Nombre del cliente',
  customer_email: 'Correo electrónico del cliente',
  customer_mobile: 'Teléfono móvil del cliente',
  checkout_details: 'Detalles de orden de checkout'
}
